import { AuthenticationRetryApiClientDecorator, AuthenticationRetryLoginClientDecorator } from "./AuthenticationRetryApiClientDecorator";
import { buildBearerApiClient, buildBearerLoginClient } from "./BearerApiClient";

export const buildApiClient = (...args: Parameters<typeof buildBearerApiClient>) => {
    return new AuthenticationRetryApiClientDecorator(buildBearerApiClient(...args));
};

export const buildLoginClient = (...args: Parameters<typeof buildBearerLoginClient>) => {
    return new AuthenticationRetryLoginClientDecorator(buildBearerLoginClient(...args));
};